import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Space } from 'antd';
import { getNodeData, isAdmin, saveCyNodeInfo, selectNode } from '../../scripts/cy-core';
import { uploadFiles } from '../../scripts/aws-s3';
import ImageUpload from './ImageUpload';
import GraphButton from '../../../GraphButton';
import { setCurrentNode, setIsSaving } from '../../scripts/tree-slice';
// import { femaleImg, maleImg } from '../../scripts/cy-css';

const CurrentNode = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const currentNode = useSelector((state) => state.tree.currentNode);
  // const treeData = useSelector((state) => state.tree.treeData);
  const [cyNodeData, setCyNodeData] = useState(null);
  // used to identify if this is the first time CurrentNode is loaded to skip selectNode

  const [birthDay, setBirthDay] = useState('');
  const [birthMonth, setBirthMonth] = useState('');
  const [birthYear, setBirthYear] = useState('');

  const yearOptions = [];
  const monthOptions = [];
  const dayOptions = [];

  for (let i = new Date().getFullYear(); i > 1000; i -= 1) {
    yearOptions.push({ value: i.toString(), label: i.toString() });
  }
  for (let i = 1; i < 13; i += 1) {
    monthOptions.push({ value: i.toString(), label: i.toString() });
  }
  for (let i = 1; i < 32; i += 1) {
    dayOptions.push({ value: i.toString(), label: i.toString() });
  }

  const checkDefaultImg = (e) => {
    // debug-console.log('checkDefaultImg:', e);
    if (e.target.value !== currentNode.gender) {
      dispatch(setCurrentNode({ ...currentNode, gender: e.target.value }));
    }
  };

  // update cyNode info after uploading S3 image
  const onUploadS3Complete = (saveResult) => {
    const node = saveCyNodeInfo();
    const newCurrentNode = node.jsons();
    if (saveResult) {
      // autosave data if upload image success
      dispatch(setIsSaving(true));
    }

    if (newCurrentNode?.length > 0) {
      const updatedNode = newCurrentNode[0].data;

      // should use Text style for tree data, using array will have error
      dispatch(setCurrentNode(updatedNode));
    }
  };

  useEffect(() => {
    // debug-console.log('[Use Effect] currentNode=', currentNode.name);
    if (currentNode?.id) {
      selectNode(currentNode.id, true, false);
      const nodeData = getNodeData(currentNode.id);
      // // debug-console.log('[Use Effect] CurrentNode: nodeData=', nodeData);
      setCyNodeData(JSON.stringify(nodeData));
      setBirthDay(currentNode.birthDay ? currentNode.birthDay : '');
      setBirthMonth(currentNode.birthMonth ? currentNode.birthMonth : '');
      setBirthYear(currentNode.birthYear ? currentNode.birthYear : '');
    }
  }, [currentNode]);

  return (
    <div id="currentNode" className="nodeInfo tab-pane fade in active">
      <ImageUpload />

      <table className="infoTable">
        <tbody>
          {isAdmin() && (
            <tr>
              <td>
                <label htmlFor="nodeId">Mã</label>
              </td>
              <td>
                <input
                  type="text"
                  className="form-control text-height-60"
                  id="nodeId"
                  name="nodeId"
                  disabled
                />
              </td>
            </tr>
          )}

          <tr>
            <td>Họ tên</td>
            <td>
              <input
                type="text"
                className="form-control text-height-60"
                placeholder="Họ Tên"
                id="cyNodeName"
                name="cyNodeName"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Sửa tên Người đang chọn"
              />
            </td>
          </tr>
          <tr>
            <td>Giới tính</td>
            <td>
              <input
                onChange={checkDefaultImg}
                type="radio"
                id="male"
                name="gender"
                value="m"
                checked={currentNode.gender === 'm'}
              />
              <label htmlFor="male">Nam</label>
              <input
                onChange={checkDefaultImg}
                type="radio"
                id="female"
                name="gender"
                value="f"
                checked={currentNode.gender === 'f'}
              />
              <label htmlFor="female">Nữ</label>
            </td>
          </tr>
          <tr>
            <td>Năm sinh</td>
            <td>
              <Space>
                <Select
                  showSearch
                  style={{ width: 75 }}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    document.getElementById('birthYear').value = value;
                  }}
                  options={yearOptions}
                  defaultValue={birthYear}
                  placeholder={birthYear}
                />

                <Select
                  showSearch
                  style={{ width: 56 }}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    document.getElementById('birthMonth').value = value;
                  }}
                  options={monthOptions}
                  defaultValue={birthMonth}
                  placeholder={birthMonth}
                />

                <Select
                  showSearch
                  style={{ width: 56 }}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    document.getElementById('birthDay').value = value;
                  }}
                  options={dayOptions}
                  defaultValue={birthDay}
                  placeholder={birthDay}
                />
              </Space>

              <input type="hidden" id="birthYear" name="birthYear" value={birthYear} />
              <input type="hidden" id="birthMonth" name="birthMonth" value={birthMonth} />
              <input type="hidden" id="birthDay" name="birthDay" value={birthDay} />
              {/* <input type="text" className="form-control text-height-60"
                                    placeholder="Năm sinh" id="birthYear" name="birthYear"></input> */}
            </td>
          </tr>
          <tr>
            <td>Còn sống</td>
            <td>
              <input type="radio" id="isAlive" name="isDead" value="false" defaultChecked />
              <label htmlFor="isAlive">Còn sống</label>
              <input type="radio" id="isDead" name="isDead" value="true" />
              <label htmlFor="isDead">Đã mất</label>
            </td>
          </tr>
        </tbody>
      </table>
      <input type="hidden" id="imgUrl" name="imgUrl" />
      <span id="cyNodeData" className="hide" style={{ wordWrap: 'break-word' }}>
        {cyNodeData}
      </span>

      {!isAdmin() && <input type="hidden" id="nodeId" name="nodeId" />}

      <GraphButton
        id="btnUpdateInfo"
        label="Cập nhật thông tin"
        onClick={() => uploadFiles(user?.userId, onUploadS3Complete)}
        title="Cập nhật thông tin chỉnh sửa"
      />
    </div>
  );
};

export default CurrentNode;
